import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 路由懒加载
const Dashboard = () => import('../views/Dashboard.vue');
const ArticleList = () => import('../views/ArticleList.vue');
const ArticleEdit = () => import('../views/ArticleEdit.vue');
const ArticleCreate = () => import('../views/ArticleCreate.vue');
const ArticlePreview = () => import('../views/ArticlePreview.vue');
const ImageLibrary = () => import('../views/ImageLibrary.vue');
const ArticleCategories = () => import('../views/ArticleCategories.vue');

// AI设置页面（新增）
const AISettings = () => import('../views/AISettings.vue');

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { title: '控制台', icon: 'el-icon-s-home' }
  },
  {
    path: '/articles',
    name: 'ArticleList',
    component: ArticleList,
    meta: { title: '文章列表', icon: 'el-icon-document' }
  },
  {
    path: '/articles/create',
    name: 'ArticleCreate',
    component: ArticleCreate,
    meta: { title: '创建文章', icon: 'el-icon-plus' }
  },
  {
    path: '/articles/edit/:id',
    name: 'ArticleEdit',
    component: ArticleEdit,
    meta: { title: '编辑文章', icon: 'el-icon-edit', activeMenu: '/articles' },
    hidden: true
  },
  {
    path: '/articles/preview/:id',
    name: 'ArticlePreview',
    component: ArticlePreview,
    meta: { title: '文章预览', icon: 'el-icon-view', activeMenu: '/articles' },
    hidden: true
  },
  {
    path: '/categories',
    name: 'ArticleCategories',
    component: ArticleCategories,
    meta: { title: '分类管理', icon: 'el-icon-collection-tag' }
  },
  {
    path: '/image-library',
    name: 'ImageLibrary',
    component: ImageLibrary,
    meta: { title: '图片库', icon: 'el-icon-picture' }
  },
  {
    path: '/ai-settings',
    name: 'AISettings',
    component: AISettings,
    meta: { title: 'AI设置', icon: 'el-icon-setting' }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router; 